// extracted by mini-css-extract-plugin
export var container = "_70-0";
export var infoButton = "_70-1";
export var label = "_70-3";
export var labelExpanded = "_70-4";
export var price = "_70-5";
export var priceExpanded = "_70-6";
export var title = "_70-2";